import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SharedService } from '../../../shared/shared.service';
import { Logger } from 'angular2-logger/core';
import { ReportService } from '../report.service';
import { empty } from 'rxjs/Observer';
import { NgxSpinnerService } from 'ngx-spinner';
import { RoomService } from '../../../dashboard/chat/room/room.service';
import { ThrowStmt } from '@angular/compiler';

declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-report', 
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'], 
  providers: [ReportService]
})

export class ReportComponent implements OnInit, AfterViewChecked {
  public saidReturn: any;
  public filter: FormGroup; 
  public type_report: any;
  public state_report_array: Array<any> = [];
  public state_report: any;
  public state_report2: any;
  public state_report_array2: Array<any> = [];
  public date_start_report: string;
  public date_end_report: string;
  public info: any;
  public g_bars: boolean;
  public g_doughnut: boolean;
  public g_pie: boolean;
  public g_chat: boolean;
  public g_detalle: boolean;
  public dropdownList = []; 
  public dropdownList2 = [];
  public dropdownList3 = [];
  public selectedItems = [];
  public selectedItems2 = [];
  public dropdownSettings = {};
  public dropdownSettings2 = {};
  public dataNueva = [];
  public dataTable : any;
  public dataHistorialRooms : any;
  public total : any;
  private TransferidoStatus = [];
  private IsTransferido:boolean = false;
  //public load: boolean;
  public doughnut_average: boolean;

  public tipoEstado : any;
  public userId : any;

  public title_toModal: string;
  public body_toModal: string;
  public room_id: any;
  public currentP: any;
  public rooms: any;
  public msgs_init: any;
  public states: any;
  public hiddenStatus : any;

  public tipoReporte: String;


  constructor(
    private _saidService : RoomService,
    private route: Router,
    private fb: FormBuilder,
    public _sharedService: SharedService,
    private logger: Logger,
    private _service: ReportService,
    private spinner: NgxSpinnerService) {
    this.tipoReporte = "Tipo de Reporte";
   // this.g_bars = true; // Graficos de barra por defecto
    this.filter = this.fb.group({
      date_start_report: ['', Validators.required],
      date_end_report: ['', Validators.required],
      state_report: [],
      state_report2: [],
      report_type: ['', Validators.required],
    });

    this.rooms = {};
  }

    ngOnInit() {
    //console.log(this.route.url); 
    
    let data = {
      auth_token: this._sharedService.getCookie("auth_token"),
      tipo : 'reporteChats'
    };
    //console.log("Data token:" + data.auth_token);
    this._saidService.getIds(data).subscribe((returndata)=>{
      //this.saidReturn = JSON.parse(returndata);
      this.saidReturn = returndata.message;
      //console.log("Esto es lo que traigo: ",this.saidReturn);
      let valuei= 0;
      for (let i = 0; i < this.saidReturn.descripciones.length; i++) {
        //newData[i-1] = this.saidReturn[i-1].description;
        //console.log(i);
        this.dropdownList2[i] = 
          {'id': this.saidReturn.descripciones[i].id_room_status, 'itemName':this.saidReturn.descripciones[i].description};
          valuei = i;  
      }

      let value= 0;
      for (let i = 0; i < this.saidReturn.todosTags.length; i++) {
        this.dropdownList3[i] = 
          {'id': this.saidReturn.todosTags[i].id, 'itemName':this.saidReturn.todosTags[i].detalle_tags};
          value = i;  
      }

      this.TransferidoStatus = this.saidReturn.categorias.filter(x => x.name =='TRANSFERIDO');
       if(this.TransferidoStatus.length > 0 ){
         this.dropdownList2[valuei++]=
        {'id':'Transferido','itemName':'Cerrado por transferido'}
      } 

      
      console.log(this.dropdownList2);
      //console.log(this.dropdownList);
      //console.log(this.dropdownList2);
    });

    /*this.date_start_report = '2017-10-19';
    this.date_end_report = '2018-10-19';
    this.state_report = [9];
    this.type_report = 'status';*/
    
    this.dropdownList = [ 
      { 'id': 1, 'itemName': 'Abiertos' }, 
      { 'id': 2, 'itemName': 'Pendientes' },
      { 'id': 3, 'itemName': 'Atendidos' },
      { 'id': 4, 'itemName': 'Cerrados por el agente' },
      { 'id': 5, 'itemName': 'Cerrados por el cliente' },
      { 'id': 6, 'itemName': 'Cerrados por tiempo de espera' },
      { 'id': 7, 'itemName': 'Borrado' },
    ];  
    this.selectedItems = [
      /*{'id': 1, 'itemName': 'Open'},
    {'id': 2, 'itemName': 'Pending'},
    {'id': 3, 'itemName': 'Attending'}*/
    ];
    this.dropdownSettings = { 
      singleSelection: false,
      text: 'Seleccionar Estado',
      searchPlaceholderText: 'Buscar',
      selectAllText: 'Seleccionar Todos',
      unSelectAllText: 'Deseleccionar Todos',
      enableSearchFilter: true,
      classes: 'myclass custom-class'
    };

    this.dropdownSettings2 = { 
      singleSelection: false,
      text: 'Seleccionar etiquetas',
      searchPlaceholderText: 'Buscar',
      selectAllText: 'Seleccionar Todos',
      unSelectAllText: 'Deseleccionar Todos',
      enableSearchFilter: true,
      classes: 'myclass custom-class'
    };
    
  }

  onItemSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  OnItemDeSelect(item: any) {
    console.log(item);
    console.log(this.filter.value.state_report2);
  }
  onSelectAll(items: any) {
    console.log(items);
  }
  onDeSelectAll(items: any) {
    console.log(items);
  }

  ngAfterViewChecked() {
      if(this.filter.value.report_type == 'tags') {
        this.hiddenStatus = false;
      } else {
        this.hiddenStatus = true;
      }
  }

  onFilter() {
    console.log('report');
    //this.load = true;
    this.spinner.show();
    this.type_report = this.filter.value.report_type;
    //this.state_report.push(parseInt(this.filter.value.state_report));

    //console.log(this.filter.value.state_report[1].id);

    this.state_report_array = [];
    this.state_report_array2 = [];

    if(this.hiddenStatus == true) {
      if (this.filter.value.state_report.length !== 0) {
        this.filter.value.state_report.forEach(element => {
          this.state_report_array.push(element.id);
        });
      }
    } else {
      if (this.filter.value.state_report2.length !== 0) {
        this.filter.value.state_report2.forEach(element => {
          this.state_report_array.push(element.id);
          this.state_report_array2.push(element.id);
        });
      }
    }

    if(this.state_report_array.indexOf('Transferido') != -1){
      this.IsTransferido = true;
    }else{
      this.IsTransferido = false;
    }
    /* console.log("STATES");
    console.log(this.state_report_array); */

    if(this._sharedService.user.role_id == '3'){
      this.userId = this._sharedService.user.id;
    } else {
      this.userId = '';
    }

    let data = {
      auth_token: this._sharedService.getCookie('auth_token'),
      report_type: this.filter.value.report_type,  //3 states: status, average, status_agent
      status: this.state_report_array,
      tags : this.state_report_array2,
      date_start: this.filter.value.date_start_report,
      date_end: this.filter.value.date_end_report,
      is_transferido:this.IsTransferido,
      g_chat : this.g_chat,
      g_detalle : this.g_detalle,
      usuario : this.userId
    };

      this._service.getReportData(data).subscribe( 
        data => { 
          if (data.status) { 
            this.logger.log(data.data);

            if (data.data.length === 0) {
              $('#DataEmpty').modal('toggle');
              //this.load = false;
              this.spinner.hide();
            } else {
              this.info = data.data;


              if(this.g_chat == false && this.g_detalle == false){
                this.spinner.hide();

                for (let i = 0; i < this.info.length; i++) {
                  if(this.filter.value.report_type === 'status_agent'){
                    let serieUserStatus = this.info[i].serie+'-'+this.info[i].serie2;
                    this.info[i].serie3 = serieUserStatus;
                  }else{
                    this.info[i].serie3 = this.info[i].serie;
                  } 
                }

                if (this.filter.value.report_type === 'average') {

                  this.doughnut_average = true;
  
                  for (let i = 0; i < this.info.length; i++) {
                    this.info[i].serie = 'Atendidos';
                    this.info[i].quantity = (parseInt(this.info[i].quantity )/60)
                    this.info[i].quantity = this.info[i].quantity.toFixed(2);
                  } 
  
                  //console.log(this.info[0].quantity);
                  // console.log(this.info.length);
                  /*for (let i = 0; i < this.info.length; i++) {
                  let value_quantity = this.info[i].quantity;
                  let value_end_quantity = value_quantity / 2;
                  this.info[i].quantity = value_end_quantity;
                  }*/
                } else {
                  this.doughnut_average = false;
                }

                console.log("info responsive", this.info);

              } else {
                if (this.g_detalle == true) {
                    this.tipoEstado = this.filter.value.report_type;
                    this.dataTable = true;
                    this.spinner.hide();
                    this.dataTable = data.data;
                    this.total = this.info.length;

                } else {
                  if (this.filter.value.report_type === 'average') {
                    for (let i = 0; i < this.info.length; i++) {
                      this.info[i].cantidad = (parseInt(this.info[i].cantidad )/60)
                      this.info[i].cantidad = this.info[i].cantidad.toFixed(2);
                      this.info[i].promedio = ((this.info[i].cantidad * 100) / 1000).toFixed(1) + '%';
                    } 
                  }
                    this.tipoEstado = this.filter.value.report_type;
                    this.dataTable = true;
                    this.spinner.hide();
                    this.dataTable = data.data;
                    this.total = this.info.length;
                }
              }
            }
          } else {
            this.logger.log('no report data received');
          }
        }
      );
    /*} else {
        this.tipoEstado = this.filter.value.report_type;
        let data = {
          auth_token: this._sharedService.getCookie('auth_token'),
          report_type: this.filter.value.report_type, 
          status: this.state_report_array,
          date_start: this.filter.value.date_start_report,
          date_end: this.filter.value.date_end_report
        };
        this._service.getReportTabla(data).subscribe(
          data => { 
            this.dataTable = true;
            this.spinner.hide();
            this.logger.log('report data received');
            

            this.info = data.data;
            this.dataTable = data.data;
            this.total = this.info.length;
            
          }
        );
    }*/

    this.state_report_array = [];
    /*this.date_start_report = this.filter.value.date_start_report;
       this.date_end_report = this.filter.value.date_end_report;
       this.state_report = [3];
       this.type_report = this.filter.value.report_type;*/
    //console.log(this.filter.value.date_start_report);
    //console.log(this.filter.value.date_end_report);
    //console.log(this.filter.value.state_report);
    //console.log(this.filter.value.report_type);
  }

  change_graphic(graphic) {
    this.dataTable = false;
    switch (graphic) {
      case 'bars':
        this.tipoReporte = "Reporte de Chats en Gráfico de Barras";
        this.g_bars = true;
        this.g_doughnut = false;
        this.g_pie = false;
        this.g_chat = false;
        this.g_detalle = false;
        break;
      case 'doughnut':
        this.tipoReporte = "Reporte de Chats en Gráfico de Dona";
        this.g_bars = false;
        this.g_doughnut = true;
        this.g_pie = false;
        this.g_chat = false;
        this.g_detalle = false;
        break;
      case 'pie':
        this.tipoReporte = "Reporte de Chats en Gráfico de Torta";
        this.g_bars = false;
        this.g_doughnut = false;
        this.g_pie = true;
        this.g_chat = false;
        this.g_detalle = false;
        break;
      case 'chat':
          this.tipoReporte = "Reporte de Chats";
          this.g_bars = false;
          this.g_doughnut = false;
          this.g_pie = false;
          this.g_chat = true;
          this.g_detalle = false;
          break;
      case 'detalle':
            this.tipoReporte = "Reporte de Chats";
            this.g_bars = false;
            this.g_doughnut = false;
            this.g_pie = false;
            this.g_chat = false;
            this.g_detalle = true;
            break;
      default:
        this.tipoReporte = "Tipo de Reporte";
        this.g_bars = false;
    }

    //console.log("tipoReporte", this.tipoReporte);
    /* if (graphic === 'bars') {
       this.g_bars = true;
       this.g_doughnut = false;
     }else {
       this.g_doughnut = true;
       this.g_bars = false;
     }*/
  }
  exportAsXLSX():void {
    this._service.exportAsExcelFile(this.dataTable, 'reporte');
  }

  exportHistorialExc():void {
    this._service.exportAsExcelFile(this.dataHistorialRooms, 'reporte_historial');
  }

  verConversacion(id) {
    this.room_id = id;

    this.spinner.show();

    let data = { 
      auth_token: this._sharedService.getCookie('auth_token'),
      room_id: this.room_id,
      // page: id_page
    };

    console.log(data);

    this._service.getRoomMsgs(data).subscribe(
      data => {
        console.log("Este es data: ", data);
        if (data.status) {

          //   if (data.data.last_page >= data.data.current_page) {
          // saving everything into "rooms"
          this.logger.log("received history:"); 
          this.logger.log(data);
          //console.log('Prueba de data2');
          //console.log(data.data);
          console.log(data.data);
          if(data.data) {
            this.currentP = data.data.current_page;
            if (!this.rooms)
              this.rooms = {};

            if (!this.rooms.msgs) {
              this.rooms.msgs = [];
            }

            if (this.rooms.msgs.length === 0) {
              this.dataHistorialRooms = data.data.dataReport;
              this.rooms.msgs = data.data.data;
              this.msgs_init = data.data.data;
            } else {
              this.rooms.msgs = [];
              this.rooms.msgs = data.data.data; 
              this.dataHistorialRooms = data.data.dataReport;
            }

            //this.load = false;
            this.states = {
              currentPage: this.rooms.current_page = data.data.current_page,
              lastPage: this.rooms.current_page = data.data.last_page
            };
          }
          //   }

        } else {
          //this.load = false;
          this.logger.log(data.message);
        }
        console.log('Rooms-->',this.rooms);

        this.spinner.hide();

        this.title_toModal = "Conversación No. " + this.room_id;
        this.body_toModal = "Si hay información";
        $('#historialRooms').modal('toggle',{backdrop: false});
        $('#historialRooms').appendTo("body");

      },
      error => {
        console.log("Justo antes");
        this.logger.log(error);

      }
    );
    
}

}


// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/report/report/report.component.ts